/* eslint-disable no-return-assign */

import {createPortal} from 'react-dom';

const cache = {};

const getContainer = container => {
    if (typeof container === 'string') {
        if (container in cache) return cache[container];

        return cache[container] = document.getElementById(container);
    }

    return container;
};

const Portal = ({children, container}) => getContainer(container) && createPortal(
    children,
    getContainer(container),
);

export default Portal;



// WEBPACK FOOTER //
// ./scripts/components/Portal.js